import { getSoftDeletedShortLabel } from "@/lib/file-unavailable";
import { FileDto } from "@/lib/gen-api";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faArrowUpToBracket,
  faBan,
  faCheck,
  faExclamationTriangle,
  faGear,
  faTrash,
  faXmark,
} from "@nnr/fontawesome-sharp-light/icons/sharp/light";

function softDeleteIcon(deletedReason: FileDto["deletedReason"]) {
  if (deletedReason === "permission_lost") {
    return <FontAwesomeIcon icon={faBan} className="text-orange-600" />;
  }
  if (deletedReason === "unsupported") {
    return (
      <FontAwesomeIcon
        icon={faExclamationTriangle}
        className="text-orange-600"
      />
    );
  }
  return <FontAwesomeIcon icon={faTrash} className="text-orange-600" />;
}

export function FileStatus(props: {
  file: Pick<
    FileDto,
    | "isSearchable"
    | "isParsing"
    | "is_uploaded"
    | "markdownPath"
    | "error"
    | "dateDeleted"
    | "deletedReason"
  >;
  label?: boolean;
}) {
  const getIconAndLabel = () => {
    if (props.file.dateDeleted) {
      return {
        icon: softDeleteIcon(props.file.deletedReason),
        label: getSoftDeletedShortLabel(props.file.deletedReason),
      };
    }
    if (props.file.isParsing) {
      return {
        icon: (
          <FontAwesomeIcon
            icon={faGear}
            className="animate-[spin_2s_linear_infinite]"
          />
        ),
        label: "Parsing...",
      };
    }
    if (props.file.error) {
      return {
        icon: (
          <FontAwesomeIcon
            icon={faExclamationTriangle}
            className="text-orange-500"
          />
        ),
        label: "Error",
      };
    }
    if (!props.file.is_uploaded) {
      return {
        icon: <FontAwesomeIcon icon={faXmark} />,
        label: "Not uploaded",
      };
    }
    if (props.file.markdownPath && props.file.isSearchable) {
      return {
        icon: <FontAwesomeIcon icon={faCheck} className="text-green-800" />,
        label: "Parsed",
      };
    }
    return {
      icon: <FontAwesomeIcon icon={faArrowUpToBracket} />,
      label: "Uploaded",
    };
  };

  const { icon, label } = getIconAndLabel();

  return (
    <div className="flex items-center gap-2">
      {icon}
      {label && <span className="text-foreground-8 text-sm">{label}</span>}
    </div>
  );
}
